import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getScenarioButtonText } from '../utils/scenarioData';

function ScenarioButtonText() {
  const { t } = useTranslation();
  const { scenario } = useSelector((state) => state.scenario);
  return <>{t(getScenarioButtonText(scenario))}</>;
}

export default ScenarioButtonText;
